import { z } from 'zod';
/**
 * Sürüm kontrolü.
 *
 * Uygulama iki katmanda güncellenir:
 *
 *  1. **Arayüz (web) güncellemesi** — sık. Sunucudaki `webBuild` cihazdakinden
 *     büyükse arayüz sessizce yenilenir. APK dağıtımı gerekmez; günlük
 *     düzeltmeler böyle yayılır.
 *
 *  2. **APK güncellemesi** — nadir. Yalnızca native yetenek değiştiğinde
 *     (yeni eklenti, izin, Android sürümü) gerekir. Sunucudaki `nativeCode`
 *     cihazdakinden büyükse kullanıcıya zorunlu güncelleme ekranı çıkar.
 */
export const appVersionSchema = z.object({
    /** Android versionCode. */
    nativeCode: z.number().int(),
    /** Kullanıcıya gösterilen ad: "2.1.0". */
    versionName: z.string(),
    /** Arayüz yayın numarası. */
    webBuild: z.number().int(),
    apkUrl: z.string().nullable(),
    apkBytes: z.number().nullable(),
    /** Eski sürüm çalışmayı reddetsin mi? */
    mandatory: z.boolean(),
    notes: z.string().nullable(),
});
/**
 * Ne yapılacağına karar verir.
 *
 * APK güncellemesi arayüz güncellemesinden önce gelir: native kabuk eskiyse
 * yeni arayüz kodu zaten çalışmayabilir (eksik eklenti, eksik izin).
 */
export function decideUpdate(server, installed) {
    // Tarayıcıda APK diye bir şey yok; yalnızca arayüz güncellenir.
    if (installed.nativeCode !== null && server.nativeCode > installed.nativeCode) {
        return server.mandatory ? 'apk-required' : 'apk-optional';
    }
    if (server.webBuild > installed.webBuild)
        return 'reload';
    return 'none';
}
//# sourceMappingURL=version.js.map